import { useAppStore } from "@hooks/useAppStore";
import type { MixedItemTag } from "@memorang/types";
import { useTranslation } from "react-i18next";
import { getPracticeTestsQuizzesAndExams } from "../../helpers/practice-tests-data";
import { buildRecommendedTestTasks } from "./buildRecommendedTestTasks";
import type { RecommendedTestInventory } from "./useRecommendedTestInventory";

export const useRecommendedTestTasks = ({
	skills,
	preferredSkillIds,
	inventory,
}: {
	skills: MixedItemTag[];
	preferredSkillIds?: string[];
	inventory: RecommendedTestInventory;
}) => {
	const { t, i18n } = useTranslation();
	const {
		allTests,
		handlePracticeTestSession,
		selectedExamId,
		creatingSession,
	} = inventory;
	const diagnosticLabel = useAppStore((state) => state.exam.diagnosticLabel);
	const { practiceTests, practiceTestQuizzes: diagnostics } =
		getPracticeTestsQuizzesAndExams(allTests);
	return buildRecommendedTestTasks({
		allTests,
		practiceTests,
		diagnostics,
		skills,
		preferredSkillIds,
		diagnosticLabel:
			diagnosticLabel?.[i18n.language] ??
			t("dashboard.recommendedTasks.diagnosticDefaultLabel"),
		t,
		taskContext: {
			t,
			handlePracticeTestSession,
			selectedExamId,
			creatingSession,
		},
	});
};
